<template>
  <div>
    <v-container>
      <v-row v-if="!$store.state.isLoggedIn" class="text-center" justify="center" align="center">
        <v-col cols="12" :sm="8">
          <v-row>
            <v-col cols="12">
              <span style="white-space:pre-wrap;">{{$t('home.welcome-text', {product: $tenant.title})}}</span>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="$tenant.home.content == 'featureSlider'" class="ma-0 pa-0" cols="12" :sm="8" :md="8">
          <features-slide-content />
        </v-col>
      </v-row>
      <v-row v-if="$store.state.isLoggedIn" class="text-center" justify="center" align="center">
        <v-col cols="8" :md="6">
          <v-img
            :alt="$tenant.title + ' Logo'"
            class="shrink"
            contain
            :src="$tenant.mainLogo"
            transition="scale-transition"
            width="100%"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container class="advertising-container" v-if="$tenant.home.content == 'advertising'">
      <advertising-content/>
    </v-container>
    <v-container fluid class="align-center justify-center text-center">
      <v-row v-if="!$store.state.isLoggedIn" class="align-center justify-center text-center">
        <v-col cols="12" :sm="8">
          <v-btn to="/register" class="primary" style="width:100%;">
            <v-icon left>mdi-account-plus</v-icon>{{$t('home.register-now-for-free')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!$store.state.isLoggedIn" class="align-center justify-center text-center">
        <v-col cols="12" :sm="8">
          <v-row>
            <v-col cols="6">
              <span class="caption">{{$t('home.already-have-an-account-question')}}</span>
            </v-col>
            <v-col>
              <v-btn to="/login" class="primary">
                <v-icon left>mdi-login</v-icon>{{$t('common.login')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="$store.state.isLoggedIn" class="pt-2">
        <v-col>
          <v-btn to="/dashboard" class="primary">
            <v-icon left>mdi-view-dashboard</v-icon>{{$t('home.goto-dashboard')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import FeaturesSlideContent from "@/widgets/FeaturesSlideContent";
import AdvertisingContent from '@/widgets/AdvertisingContent.vue';

export default {
  name: "Home",
  components: {
    FeaturesSlideContent,
    AdvertisingContent,
  },

  data: () => ({}),
  methods: {
  }
};
</script>
